<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="card-title">
                    <h4>Activity</h4>
                </div>
                @if (organization()?.organizationId) {
                <ms-audit-logs [entityId]="organization()?.organizationId" [entityType]="AuditEntityType.Organization">
                </ms-audit-logs>
                }
            </div>
        </div>
    </div>
</div>